// @flow
import React, {Component} from 'react';
import {StyleSheet, View} from 'react-native';
import {
  ActivityIndicator,
  Button,
  EmphasizedSubText,
  Text,
} from 'trpc-react-native-ui';
import Icon from '../Icon/Icon';

import theme from '../../../theme-config';

class FullButton extends Component<Props> {
  render() {
    const styles = getStyles();
    const {
      iconName,
      iconSize,
      neutralColors,
      lessImpedanceColors,
      text,
      style,
      disabled,
      isLoading,
      textStyle,
      buttonStyle,
      emphasizeSubText,
      isNotLoadingTestID,
      minHeight = 45,
      ...rest
    } = this.props;

    const isInactive = disabled || isLoading;

    const textStyles = [
      styles.buttonText,
      neutralColors && styles.neutralColorsButtonText,
      lessImpedanceColors && styles.lessImpedanceColorsButtonText,
      textStyle,
    ];

    return (
      <Button 
        {...rest} 
        disabled={isInactive}
        shadowEnabled={true}
        style={[
          styles.buttonBase,
          neutralColors && styles.neutralColorsButton,
          lessImpedanceColors && styles.lessImpedanceColorsButton,
          style,
          { minHeight }
        ]}
      >
        <View style={styles.contentContainer}>
          {isLoading ? (
            <ActivityIndicator
              color={
                ((textStyle && StyleSheet.flatten(textStyle)) || {}).color ||
                theme.buttons.PRIMARY.textColor
              }
            />
          ) : emphasizeSubText ? (
            <EmphasizedSubText
              style={textStyles}
              emphStyle={styles.underline}
              text={text}
            />
          ) : (
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            {iconName && <Icon name={iconName} size={iconSize} style={styles.icon} />}
              <Text style={textStyles} testID={isNotLoadingTestID}>
                {text}
              </Text>
            </View>
          )}
        </View>
      </Button>
    );
  }
}

type Props = {
  text: string,
  style?: any,
  textStyle?: any,
  buttonStyle?: any,
  neutralColors?: boolean,
  lessImpedanceColors?: boolean,
  disabled?: boolean,
  isLoading?: boolean,
  emphasizeSubText?: boolean,
  isNotLoadingTestID?: boolean,
  onPress?: ?Function,
  onLongPress?: ?Function,
  testID?: string,
  minHeight?: Number,
};

const getStyles = () =>
  StyleSheet.create({
    buttonBase: {
      backgroundColor: theme.primaryColor,
      borderRadius: theme.buttons.borderRadius,
      alignItems: 'center',
      justifyContent: 'center',
    },
    contentContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 10,
    },
    neutralColorsButton: {
      backgroundColor: theme.neutralColor,
    },
    lessImpedanceColorsButton: {
      backgroundColor: theme.transparentPrimaryColor,
    },
    buttonText: {
      color: theme.overPrimaryColor,
      fontSize: 20,
      textAlign: 'center',
    },
    neutralColorsButtonText: {
      color: theme.overPrimaryColor,
    },
    lessImpedanceColorsButtonText: {
      color: theme.overPrimaryColor,
    },
    underline: {
      textDecorationLine: 'underline',
    },
    icon: {
      color: theme.overPrimaryColor,
      marginHorizontal: 10,
    },
  });

export default FullButton;